
var domReady = function(callback) {
	document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};

// Add `.has-menu` modifier to page on load.
domReady(function() {
	var bodyClass = document.querySelector('body').classList;
	var navClass = document.querySelector('[data-navigation="site-menu"]').classList;
	bodyClass.remove('has-menu');
	navClass.add('is-closed');
});


// Add `.has-menu` modifier to page on load.
domReady(function() {

});

// Open and close menu on button click.
domReady(function() {
	document.querySelector('#js-site-menu-toggle').addEventListener('click', function(e) {
		e.preventDefault();

		var bodyClass = document.querySelector('body').classList;
		bodyClass.toggle('has-menu');

		var navClass = document.querySelector('[data-navigation="site-menu"]').classList;
		navClass.toggle('is-closed');

	});
});

// Writen in jQuery for speed. @TODO Convert to vanilla JavaScript.
$( document ).ready(function() {

	$( '[data-navigation="site-toggle-sub-menu"]' ).click(function(event){

		event.preventDefault();

		if ( $( this ).parent( '.c-menu__item' ).hasClass( 'is-open' ) ) {

			// Close this menu.
			$( this ).parent( '.c-menu__item' ).removeClass( 'is-open' );

		} else {

			// Close all other menus.
			$( '.is-open' ).removeClass( 'is-open' );

			// Open selected menu.
			$( this ).parent( '.c-menu__item' ).addClass( 'is-open' );

		}

	});
});

$( document ).ready(function() {

	$( '.c-team-cat-list li' ).click(function(event){

		event.preventDefault();
		$attr = $(this).attr('id');
		console.log($attr);
		if ($(this).hasClass("c-show-all-team")) {
			$('.c-team-list .c-card--team').show();
			$('.c-team-cat-list li').removeClass('active');
			$( this ).addClass('active');
			$(".c-team-cat-list-mobile-button").text("Select Department");
	        if ($(window).width() < 992) {
				$(".c-team-cat-list-mobile-button").removeClass("active");
				$("ul.c-team-cat-list").addClass('hidden');

	        }
		} else if ( $( this ).hasClass( 'active' ) ) {
			$('.c-team-list .c-card--team').show();
			$( this ).removeClass('active');
			$('.c-show-all-team').addClass('active');
			$(".c-team-cat-list-mobile-button").text("Select Department");
			if ($(window).width() < 992) {
				$(".c-team-cat-list-mobile-button").removeClass("active");
				$("ul.c-team-cat-list").addClass('hidden');

	        }
		} else {
			$deptName = $(this).text();
			$('.c-team-list .c-card--team').hide();
			$('.c-team-list .c-card--team.'+$attr).show();
			$('.c-team-cat-list li').removeClass('active');
			$( this ).addClass('active');
			$(".c-team-cat-list-mobile-button").text($deptName);
			if ($(window).width() < 992) {
				$(".c-team-cat-list-mobile-button").removeClass("active");
				$("ul.c-team-cat-list").addClass('hidden');
	        }
		}

		var $descHeight = 0;
		var $descWrap = 0;
		var $count = 0;
		var $wrapCount = 0;
		var $boxCount = 0;
		var $maxCount = $(".c-card__header:visible").length;

		console.log($maxCount)

		$(".c-team-list .c-card__header").css('height', 'auto');

		if($(window).width() > 781) {
			if ($(window).width() < 992) {
				$descWrap = 2;
			} else if ($(window).width() < 1250) {
				$descWrap = 3;	
			} else {
				$descWrap = 5;
			}

			// console.log($count);
			// console.log($descWrap);
			// console.log($wrapCount);

			$(".c-team-list .c-card__header:visible").each(function() {
				$(this).addClass('heightCheck');
				$count++;
				$boxCount++;
				console.log($count);
				if ($(this).outerHeight() > $descHeight) {
					$descHeight = $(this).outerHeight();
				}

				if($count == $descWrap || $boxCount == $maxCount) {
					$(".c-team-list .c-card__header.heightCheck").outerHeight($descHeight);
					$descHeight = 0;
					$count = 0;
					$wrapCount++;
					$(".c-team-list .c-card__header").removeClass('heightCheck');
					// console.log('wrapped');
				}
			});

			$count = 0;
			$wrapCount = 0;
		} else {
			$(".c-team-list .c-card__header").css('height', 'auto');
		}        
	});

	$(".c-team-cat-list-mobile-button").click(function(event){

		event.preventDefault();

		if($(this).hasClass("active")) {
			$(this).removeClass("active");
			$("ul.c-team-cat-list").addClass('hidden');

		} else {
			$(this).addClass("active");
			$("ul.c-team-cat-list").removeClass('hidden');
		}

		if ($(window).width() < 992) {
            $(".c-team-cat-list-mobile-button").show();
			$("ul.c-team-cat-list").addClass('hidden');
        } else {
        	$(".c-team-cat-list-mobile-button").hide();
			$("ul.c-team-cat-list").removeClass('hidden');
        }

		var $descHeight = 0;
		var $descWrap = 0;
		var $count = 0;
		var $wrapCount = 0;
		var $boxCount = 0;
		var $maxCount = $(".c-card__header:visible").length;

		console.log($maxCount)

		$(".c-team-list .c-card__header").css('height', 'auto');

		if($(window).width() > 781) {
			if ($(window).width() < 992) {
				$descWrap = 2;
			} else if ($(window).width() < 1250) {
				$descWrap = 3;	
			} else {
				$descWrap = 5;
			}

			// console.log($count);
			// console.log($descWrap);
			// console.log($wrapCount);

			$(".c-team-list .c-card__header:visible").each(function() {
				$(this).addClass('heightCheck');
				$count++;
				$boxCount++;
				console.log($count);
				if ($(this).outerHeight() > $descHeight) {
					$descHeight = $(this).outerHeight();
				}

				if($count == $descWrap || $boxCount == $maxCount) {
					$(".c-team-list .c-card__header.heightCheck").outerHeight($descHeight);
					$descHeight = 0;
					$count = 0;
					$wrapCount++;
					$(".c-team-list .c-card__header").removeClass('heightCheck');
					// console.log('wrapped');
				}
			});

			$count = 0;
			$wrapCount = 0;
		} else {
			$(".c-team-list .c-card__header").css('height', 'auto');
		}        
	});

	$(window).on('resize load orientationchange', function() {
        if ($(window).width() < 992) {
            $(".c-team-cat-list-mobile-button").show();
			$("ul.c-team-cat-list").addClass('hidden');
        } else {
        	$(".c-team-cat-list-mobile-button").hide();
			$("ul.c-team-cat-list").removeClass('hidden');
        }

		var $descHeight = 0;
		var $descWrap = 0;
		var $count = 0;
		var $wrapCount = 0;
		var $boxCount = 0;
		var $maxCount = $(".c-card__header:visible").length;

		console.log($maxCount)

		$(".c-team-list .c-card__header").css('height', 'auto');

		if($(window).width() > 781) {
			if ($(window).width() < 992) {
				$descWrap = 2;
			} else if ($(window).width() < 1250) {
				$descWrap = 3;	
			} else {
				$descWrap = 5;
			}

			// console.log($count);
			// console.log($descWrap);
			// console.log($wrapCount);

			$(".c-team-list .c-card__header:visible").each(function() {
				$(this).addClass('heightCheck');
				$count++;
				$boxCount++;
				console.log($count);
				if ($(this).outerHeight() > $descHeight) {
					$descHeight = $(this).outerHeight();
				}

				if($count == $descWrap || $boxCount == $maxCount) {
					$(".c-team-list .c-card__header.heightCheck").outerHeight($descHeight);
					$descHeight = 0;
					$count = 0;
					$wrapCount++;
					$(".c-team-list .c-card__header").removeClass('heightCheck');
					// console.log('wrapped');
				}
			});

			$count = 0;
			$wrapCount = 0;
		} else {
			$(".c-team-list .c-card__header").css('height', 'auto');
		}        
	});
});
//domReady(function() {

	/*// Listen for toggle menu interactions
	document.querySelector('.js-toggle-sub-menu').addEventListener('click', function(e) {
		e.preventDefault();
		var target = e.target;
		//if ( event.target.classList.contains('accordion-toggle') ) {
		console.log('clicked', "The index of the parent is: " +  index);
		//}

	});*/



//});*/
